// Shared bits for the Omnichannel reports.
import { Card } from "@/components/ui/card";

export const CHANNEL_OPTIONS = [
  { id: "whatsapp", name: "WhatsApp" }, { id: "email", name: "Email" },
  { id: "sms", name: "SMS" }, { id: "telegram", name: "Telegram" },
  { id: "instagram", name: "Instagram" }, { id: "facebook", name: "Facebook" },
  { id: "viber", name: "Viber" }, { id: "webchat", name: "Web Chat" },
  { id: "voicemail", name: "Voicemail" }, { id: "voice", name: "Voice Calls" },
  { id: "whatsapp_call", name: "WhatsApp Calls" },
];

export const CHANNEL_COLORS = {
  whatsapp: "#25D366", email: "#0ea5e9", sms: "#f59e0b", telegram: "#229ED9",
  instagram: "#dc2743", facebook: "#1877F2", viber: "#7360F2", webchat: "#14b8a6",
  voicemail: "#a855f7", voice: "#6366f1", whatsapp_call: "#16a34a",
};

export function fmtDur(s) {
  if (s === null || s === undefined) return "—";
  s = Math.round(s);
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ${s % 60}s`;
  const h = Math.floor(m / 60);
  if (h < 48) return `${h}h ${m % 60}m`;
  return `${Math.floor(h / 24)}d ${h % 24}h`;
}

export function Kpi({ label, value, hint, testid }) {
  return (
    <Card className="p-4" data-testid={testid}>
      <div className="text-[11px] uppercase tracking-wider text-muted-foreground">{label}</div>
      <div className="font-display text-2xl font-bold mt-1 tabular-nums">{value ?? "—"}</div>
      {hint && <div className="text-xs text-muted-foreground mt-0.5">{hint}</div>}
    </Card>
  );
}

export function Section({ title, subtitle, children, testid, right }) {
  return (
    <Card className="p-4" data-testid={testid}>
      <div className="flex items-start justify-between gap-3 mb-3">
        <div>
          <div className="font-semibold text-sm">{title}</div>
          {subtitle && <div className="text-xs text-muted-foreground">{subtitle}</div>}
        </div>
        {right}
      </div>
      {children}
    </Card>
  );
}

export function DataTable({ columns = [], rows = [], format = {}, testid, empty = "No activity in this range." }) {
  return (
    <div className="overflow-x-auto" data-testid={testid}>
      <table className="w-full text-sm whitespace-nowrap">
        <thead className="bg-muted/60">
          <tr>
            {columns.map((c, i) => (
              <th key={c.id} className={`px-3 py-2 font-semibold text-[11px] uppercase tracking-wider ${i === 0 ? "text-left" : "text-right"}`}>{c.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && (
            <tr><td colSpan={columns.length || 1} className="px-3 py-8 text-center text-muted-foreground italic">{empty}</td></tr>
          )}
          {rows.map((r, ri) => (
            <tr key={ri} className="border-t border-border/50 hover:bg-muted/20" data-testid={`${testid}-row-${ri}`}>
              {columns.map((c, i) => (
                <td key={c.id} className={`px-3 py-1.5 ${i === 0 ? "text-left font-medium" : "text-right font-mono"}`}>
                  {format[c.id] ? format[c.id](r[c.id], r) : String(r[c.id] ?? "—")}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export const pctFmt = (v) => `${v ?? 0}%`;
